import { render } from "./FormSubmissionsView.vue?vue&type=template&id=5507e96f&scoped=true"
import script from "./FormSubmissionsView.vue?vue&type=script&lang=js"
export * from "./FormSubmissionsView.vue?vue&type=script&lang=js"

import "./FormSubmissionsView.vue?vue&type=style&index=0&id=5507e96f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5507e96f"]])

export default __exports__